import { render, staticRenderFns } from "./SearchAffiliate.vue?vue&type=template&id=6b9ffdf5&scoped=true&"
import script from "./SearchAffiliate.vue?vue&type=script&lang=js&"
export * from "./SearchAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./SearchAffiliate.vue?vue&type=style&index=0&id=6b9ffdf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ffdf5",
  null
  
)

export default component.exports